/**
 * B000110 名称区分照会
 */

import {
  SText,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
} from "components";
import { labels } from "messages/labels";
import { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  meishoCdFrom: string;
  meishoCdTo: string;
  name: string;
  kanaNm: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  meishoCdFrom: "",
  meishoCdTo: "",
  name: "",
  kanaNm: "",
};

// テーブルを定義する。
const columns = [
  { field: "gyoNo", title: "行", width: "2rem" },
  { field: "meishoCd", title: "コード", width: "6rem" },
  { field: "meishoNm", title: "名称", width: "20rem" },
  { field: "meishoKana", title: "名称カナ", width: "20rem" },
  { field: "meishoKbn", hidden: true },
  { field: "meishoNm2", hidden: true },
  { field: "meishoKana2", hidden: true },
  { field: "sujikomoku1", hidden: true },
  { field: "sujikomoku2", hidden: true },
  { field: "kbn1", hidden: true },
  { field: "sakujoyoteikbn", hidden: true },
];

const focusId = "B000110";

export const B000110 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // 検索ボタン押下時に初期ページにするRef
  const isDefaultPage = useRef(false);

  const { focus, register } = useRecoilValue(focusState(focusId));

  useEffect(() => {
    focus(1);
  });

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="名称区分照会"
        gridTemplateColumns="6rem 6rem 1rem 6rem 2rem"
      >
        <SLabel>コード</SLabel>
        <SNumberField name="meishoCdFrom" code size={10} {...register(1)} />
        <SText>～</SText>
        <SNumberField name="meishoCdTo" code size={10} {...register(2)} />
        <SLabel gridColumn="1">名称</SLabel>
        <STextField
          name="name"
          size={40}
          gridColumn="span 3"
          {...register(3)}
        />
        <SLabel gridColumn="1">カナ名</SLabel>
        <STextField
          name="name"
          size={40}
          gridColumn="span 3"
          {...register(4)}
        />

        <SNormalButton
          label={labels.buttons.search}
          gridRow="4"
          gridColumn="5"
          {...register(5)}
          onClick={() => {}}
        />
      </SFrame>
      <SFrame>
        <STable data={[]} columns={columns} handleDoubleClick={() => {}} />
      </SFrame>
    </FormProvider>
  );
};
